import apiClient from '../index';

/**
 * Create a new term
 * @param {Object} termData - Data for the new term
 * @returns {Promise<Object>} The created term
 */
export const createTerm = async (termData) => {
  try {
    const response = await apiClient.post('/api/term/', termData);
    return response.data;
  } catch (error) {
    console.error('Error creating term:', error.response?.data || error.message);
    throw error;
  }
};

/**
 * Get all terms
 * @returns {Promise<Array>} List of all terms
 */
export const getTerms = async () => {
  try {
    const response = await apiClient.get('/api/term/');
    return response.data;
  } catch (error) {
    console.error('Error fetching terms:', error.response?.data || error.message);
    throw error;
  }
};

/**
 * Get term details by termId
 * @param {string} termId - The ID of the term
 * @returns {Promise<Object>} The term details
 */
export const getTerm = async (termId) => {
  if (!termId) throw new Error('Term ID is required');
  
  try {
    const response = await apiClient.get(`/api/term/${termId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching term with ID ${termId}:`, error.response?.data || error.message);
    throw error;
  }
};

/**
 * Update a term
 * @param {string} termId - The ID of the term to update
 * @param {Object} termData - The updated term data
 * @returns {Promise<Object>} The updated term
 */
export const updateTerm = async (termId, termData) => {
  if (!termId) throw new Error('Term ID is required');
  if (!termData) throw new Error('Update data is required');
  
  try {
    const response = await apiClient.put(`/api/term/${termId}`, termData);
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      throw new Error(`Term not found (ID: ${termId})`);
    }
    console.error(`Error updating term with ID ${termId}:`, error.response?.data || error.message);
    throw error;
  }
};

/**
 * Delete a term
 * @param {string} termId - The ID of the term to delete
 * @returns {Promise<Object>} The deletion confirmation
 */
export const deleteTerm = async (termId) => {
  if (!termId) throw new Error('Term ID is required');
  
  try {
    const response = await apiClient.delete(`/api/term/${termId}`);
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) {
      throw new Error('Term not found');
    }
    console.error(`Error deleting term with ID ${termId}:`, error.response?.data || error.message);
    throw error;
  }
};